import { render, staticRenderFns } from "./recruitlist.vue?vue&type=template&id=04679d36&scoped=true"
import script from "./recruitlist.vue?vue&type=script&lang=js"
export * from "./recruitlist.vue?vue&type=script&lang=js"
import style0 from "./recruitlist.vue?vue&type=style&index=0&id=04679d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04679d36",
  null
  
)

export default component.exports